import React, { useState } from "react";
import "../../../../../On_going/Published/Published_Q_list/PublishQuestionType/PdfType/pdfTypeActivity.css";
import MideaViewer from "../../../../../../../midea_viewer/MideaViewer";
import { iconData } from "../../../../../../../iconData";
import { Player } from "video-react";
import { IP } from "./../../../../../../../internalServer";
import { Tooltip, Typography } from "@mui/material";

export default function PdfQTypeActivity({ publishedAttachData, attachments }) {
  const [mideaviewer, setMideaviewer] = useState();
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [responseAttach, setResponseAttach] = useState();

  const attachformat = (para) => {
    const filePath = para;
    const fileName = filePath.split("/").pop();
    const fileNameWithoutId = fileName.split("_")[1];

    return fileNameWithoutId;
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };

  function generateLinkName(attachments) {
    if (!attachments.startsWith("https://")) {
      return "Invalid link";
    }

    // Get today’s date
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = today.getFullYear();

    // Format: link_dd-mm-yyyy
    const formattedDate = `${day}-${month}-${year}`;

    return `link_${formattedDate}`;
  }

  function generateLinkName(url) {
    try {
      const parsed = new URL(url);
      const hostname = parsed.hostname.replace("www.", "");

      // YouTube
      if (hostname.includes("youtube.com") || hostname.includes("youtu.be")) {
        return "youtube_link";
      }

      // Google Drive
      if (hostname.includes("drive.google.com")) {
        return "google_drive_link";
      }

      // Generic website
      return `${hostname}_link`;
    } catch {
      return "website_link";
    }
  }

  const getAttachmentName = (attachment) => {
    if (!attachment) return "";

    const isLink =
      attachment.startsWith("http://") || attachment.startsWith("https://");

    // Links
    if (isLink) {
      return generateLinkName(attachment);
    }

    // File Name
    const fileName = attachment.split("/").pop();

    // Remove timestamp/id prefix
    return fileName.replace(/^\d+_/, "");
  };
  return (
    <div>
      <div
        className="all_pdf_pre"
        style={isError ? { pointerEvents: "none", opacity: 0.5 } : {}}
        onClick={() => {
          const extMatch = attachments?.match(/\.([^.]+)$/);
          const ext = extMatch ? extMatch[1].toLowerCase() : "";
          const isLink =
            attachments.startsWith("http://") ||
            attachments.startsWith("https://");

          if (isLink) {
            window.open(attachments, "_blank");
          } else if (["jpg", "jpeg", "png", "mp4"].includes(ext)) {
            handleClick(attachments);
          } else if (["pdf", "ppt", "pptx"].includes(ext)) {
            handleClickforpdf(attachments);
          }
        }}
      >
        <div className="ContainerUploadedPdf d-flex gap-2 p-1">
          <div className="d-flex align-items-center pdf_logo">
            <img
              src={
                attachments.startsWith("http://") ||
                attachments.startsWith("https://")
                  ? "/images/link-icon.png"
                  : iconData?.find(
                      (i) =>
                        i.extension.toLowerCase() ===
                        attachments?.split(".").pop()?.toLowerCase(),
                    )?.icon || "/images/file-default.png"
              }
              alt=""
              className="attachLogoActivity"
            />
          </div>

          <div className="pdf_detail" style={{ marginLeft: "5px" }}>
            {/* <div
              className="pdf-txt2"
              title={attachments.split("/").pop()?.replace(/^\d+_/, "")}
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                maxWidth: "100px",
              }}
            >
              {attachments.split("/").pop()?.replace(/^\d+_/, "")}
            </div> */}
            <Tooltip title={getAttachmentName(attachments)}>
              <Typography
                variant="body2"
                sx={{
                  color: "#555",
                  maxWidth: 80,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  cursor: "pointer",
                }}
              >
                {getAttachmentName(attachments)}
              </Typography>
            </Tooltip>
          </div>
        </div>
      </div>
      {mideaviewer && (
        <MideaViewer
          closeMideaviewer={setMideaviewer}
          attachment={attachments}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" ||
        responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg">
            <div className="SubfullSizeImgActivity">
              <img
                className="crossIconImgQue"
                onClick={handleClick}
                src="/images/cross.png"
                alt="Close"
              />

              <video className="activityVideo" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  {/* {console.log("1st")} */}
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  {/* {console.log("2nd")} */}
                  <img
                    onClick={() => {
                      handleClick();
                      setIsError(false);
                    }}
                    src="/images/cross.png"
                    alt="Up Arrow"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo-1.png"
                    alt="img"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
              {/* <img
                className="imgMain"
                src={IP + responseAttach?.replace(/^\./, "")}
                alt="Full-size"
              />
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/images/cross.png"
                  alt="Up Arrow"
                />
              </div> */}
            </div>
          </div>
        ))}
    </div>
  );
}
